import React, { useEffect, useState } from 'react'
import { View, Text, StyleSheet, Image, TouchableOpacity } from 'react-native'
import Colours from '../../utils/Colours'
import BackArrow from '../../icons/BackArrow'

const TopHeaderComponent = ({ hideScreen, headerText, paddingTop }) => {

  return (

    <TouchableOpacity style={[styles.topHeaderContainer3, { paddingTop: paddingTop }]} onPress={() => hideScreen()}>
      <BackArrow color={Colours.DARKGRAY} />
      <Text style={{ fontSize: 18, color: Colours.DARKGRAY, fontFamily: 'Sen-Bold' }}>{headerText}</Text>
    </TouchableOpacity>

  )
}

const styles = StyleSheet.create({
  topHeaderContainer3: {
    display: 'flex',
    flexDirection: 'row',
    // justifyContent: 'space-between',
    //   backgroundColor: "#12ff34",
    alignItems: "center",
    padding: 15,
    // paddingTop: 20,
    gap: 15,
    // flexShrink: 1,  // ✅ Prevents text from overflowing
    flexWrap: 'wrap'
  },
})

export default TopHeaderComponent